import { format } from 'date-fns';
import { IconCrown } from '@tabler/icons-react';
import { findColorType, getQuotaColor } from 'lib/uiHelpers';

const CardMembership = ({ onBookMembership, packageItem, membership }) => {
  const getClassDescription = (type) => {
    const descriptions = {
      special: 'A fun and exclusive adventure class made just for you!',
      regular: 'Learn, play, and grow together in every session!',
      curated: 'Handpicked creative classes guided by our best teachers!',
      private: 'Your own personal class — just you and the teacher!',
      featured: 'This week’s favorite class — join the fun everyone’s talking about!',
    };
    return descriptions[type?.toLowerCase()] || 'Class description not available.';
  };

  if (!membership || !packageItem) return null;

  return (
    <div
      className={`group relative cursor-pointer rounded-2xl border-2 
      border-gray-200 hover:border-secondary-main hover:shadow-lg
      bg-gray-50 hover:bg-gray-100 text-kin-text
      transition-all duration-300 overflow-hidden flex flex-col h-full p-6 gap-4`}>
      {/* Tag */}
      <div
        className={`px-3 py-0.5 rounded-full w-max text-xs font-semibold text-white capitalize ${findColorType(
          packageItem.type.toLowerCase(),
        )}`}>
        {packageItem.type.toLowerCase() === 'collaboration'
          ? packageItem.type
          : `${packageItem.type} Class`}
      </div>

      {/* Title & Description */}
      <div className="flex flex-col gap-1">
        <p className="text-lg font-bold leading-snug line-clamp-2">{packageItem.package_name}</p>
        <p className="text-sm text-kin-text/70">{getClassDescription(packageItem.type)}</p>
      </div>

      {/* Info Section */}
      <div className="space-y-3 text-sm text-kin-text/90 flex-grow">
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="font-medium">Remaining Classes</span>
            <span className={`${getQuotaColor(membership.class_quota)} font-semibold`}>
              {membership.class_quota
                ? `${membership.class_quota} ${
                    membership.class_quota > 1 ? 'Classes' : 'Class'
                  } Left`
                : '-'}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="font-medium">Validity Period</span>
            <span>
              {packageItem.validity_period_month
                ? `Valid for ${packageItem.validity_period_month} Month${
                    packageItem.validity_period_month > 1 ? 's' : ''
                  }`
                : 'Everyday'}
            </span>
          </div>
        </div>

        <hr className="my-4 border-kin-border/40" />

        <div className="flex justify-between">
          <span className="font-medium">Active Until</span>
          <span>
            {membership.active_until ? format(membership.active_until, 'MMMM dd, yyyy') : '-'}
          </span>
        </div>
      </div>

      {/* CTA — Always Active */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onBookMembership(membership);
        }}
        className={`bg-secondary-main text-white hover:bg-secondary-dark 
        inline-flex items-center justify-center gap-1 rounded-3xl px-5 py-2 
        text-xs font-semibold transition-all duration-300 self-start`}>
        <IconCrown className="w-5 h-5" />
        BOOK NOW
      </button>
    </div>
  );
};

export default CardMembership;
